import React from 'react';
import PropTypes from 'prop-types';
import { formatAlertsDate, formatNumberWithPostfix } from '@Utils/String';



export default function CurrentAvailableResult(props) {
  const {
    selectedResultDate,
    selectedResultHits,
  } = props;

  if (!selectedResultDate) {
    return (
      <span>No alert results</span>
    );
  }

  const selectedResultDateFormatted = formatAlertsDate(selectedResultDate);

  return (
    <>
      <span>{selectedResultDateFormatted}</span>
      {selectedResultHits &&
        (
          <small className='rx-count-badge'>
            {formatNumberWithPostfix(selectedResultHits)} hits
          </small>
        )
      }
    </>
  );
}

CurrentAvailableResult.propTypes = {
  selectedResultDate: PropTypes.string,
  selectedResultHits: PropTypes.number,
};

